var map = {
	"./pr-1.png": "1bba",
	"./pr-10.png": "f122",
	"./pr-11.png": "2347",
	"./pr-2.png": "8e0e",
	"./pr-3.png": "e128",
	"./pr-4.png": "bc13",
	"./pr-5.png": "1984",
	"./pr-6.png": "b1af",
	"./pr-7.png": "6d3a",
	"./pr-8.png": "f7f4",
	"./pr-9.png": "93aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aeef";